import { ref, computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useYearSelector } from '@/services/useYearSelector'
import { useLoader } from './useLoader'
import { useError } from './useError'
import axios from '@/axios'

const isCalendarView = ref(true)
const topState = reactive({
  timelineTop: [],
})

export const useLogs = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const useCalendarView = isCalendar => {
    isCalendarView.value = isCalendar
  }
  const getTimelineTop = async year => {
    try {
      toggleShowLoader(true)
      if (!year) {
        year = new Date()
        year.setMonth(year.getMonth() - 3)
        year = year.getFullYear()
      }
      let res = await axios.get(`/timeline?year=${year}`)
      res = camelizeKeys(res)
      topState.timelineTop = res.data.timeline
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const groupByMonth = data => {
    let groupKey = 0
    let groups = data.reduce((r, obj) => {
      let month = obj.startDate.split('-')[1]
      r[month]
        ? r[month].data.push(obj)
        : (r[month] = { group: String(groupKey++), data: [obj] })
      return r
    }, {})

    let result = Object.keys(groups).map(m => {
      return groups[m]
    })
    return result
  }

  /**
   * レスポンスが正常な場合総括資料を取得する
   *
   * @param {object} response
   * @returns void
   */
  const getTimelineAfterResponse = async response => {
    if (response?.data?.code !== 0) {
      return
    }
    const { currentYear } = useYearSelector()
    await getTimelineTop(currentYear.value)
  }

  return {
    timelineTop: computed(() => topState.timelineTop),
    isCalendarView,
    useCalendarView,
    getTimelineTop,
    groupByMonth,
    getTimelineAfterResponse,
  }
}
